import React, { FC } from "react";
import Modal from "react-responsive-modal";

interface Props {
  setIsModalOpen: (isOpen: boolean) => void;
  isModalOpen: boolean;
  onConfirm: () => void;
}

const ConfirmLogoutModal: FC<Props> = ({
  setIsModalOpen,
  isModalOpen,
  onConfirm
}) => {
  return (
    <Modal
      center={true}
      onClose={() => setIsModalOpen(false)}
      open={isModalOpen}
      showCloseIcon={false}
    >
      <h2>Are you sure you want to logout?</h2>
      <h4 className="font-normal">
        If you log out any unsynced offline data will be lost.
      </h4>
      <div className="flex flex-col-reverse sm:flex-row justify-between mt-8">
        <button
          className="btn-secondary mt-4 sm:mt-0 sm:mr-8 w-full sm:w-56 "
          onClick={() => setIsModalOpen(false)}
        >
          Cancel
        </button>
        <button
          className="btn-primary  w-full sm:w-56"
          onClick={() => onConfirm()}
        >
          Logout
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmLogoutModal;
